  <div [class.dashboard-tile]="!hideWrapper" [class.hideWrapper]="hideWrapper">
    <app-grid-spinner #spinner></app-grid-spinner>
    <div class="tile-header">
      <div class="tile-header-title">{{tileTitle}}</div>
      <div class="tile-header-action">
        <button *ngIf="showAdd && hasAddObserver" [disabled]="disableAdd" mat-icon-button color="primary" [matTooltip]="addToolTip" matTooltipPosition="left" (click)='executeAddItem()'>
          <mat-icon svgIcon="cw:action_add"></mat-icon>
        </button>
        <button *ngIf="!hideRefreshButton" mat-icon-button color="primary" [matTooltip]="refreshToolTip" matTooltipPosition="left"  (click)='executeLoadItems()'>
          <mat-icon svgIcon="cw:action_refresh"></mat-icon>
        </button>
      </div>
    </div>
    <div class="tile-content">
      <div *ngIf="showEmptyListOverlay && emptyListOverlay" class="table-overlay"><div #emptyOverlayElement><ng-template *ngTemplateOutlet="emptyListOverlay"></ng-template></div></div>
      <div class="table-wrapper" [ngStyle]="calculateHeight()">
        <table mat-table [dataSource]="_tableItems" style="width:100%;" matSort [matSortActive]="defaultSortField" matSortDisableClear [matSortDirection]="defaultSortDirection" [formGroup]="filterForm">
          <ng-container *ngFor="let columnDefinition of columnDefns">
            <ng-container [matColumnDef]="columnDefinition.columnName">
              <ng-container *ngIf="columnDefinition.sortField">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="columnDefinition.sortField">
                  {{columnDefinition.columnTitle}}
                </th>
              </ng-container>
              <ng-container *ngIf="!columnDefinition.sortField">
                <th mat-header-cell *matHeaderCellDef>{{columnDefinition.columnTitle}}</th>
              </ng-container>
              <td mat-cell *matCellDef="let element" [style.min-width]="columnDefinition.minWidth">
                <span class="table-cell-wrapper" [style.max-width]="columnDefinition.maxWidth" [style.white-space]="columnDefinition.maxWidth ? 'nowrap' : null" [matTooltip]="!columnDefinition.output && columnDefinition.maxWidth ? getProperty(element, columnDefinition.columnName) : null">
                  <ng-container *ngIf="columnDefinition.output">
                    <ng-template *ngTemplateOutlet="columnDefinition.output; context: { $implicit: element }"></ng-template>
                  </ng-container>
                  <ng-container *ngIf="!columnDefinition.output">
                      {{getProperty(element, columnDefinition.columnName)}}
                  </ng-container>
                </span>
              </td>
            </ng-container>
            <ng-container [matColumnDef]="columnDefinition.columnName + '_filter'">
              <th mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="columnDefinition.filterType == 'text'">
                  <mat-form-field>
                    <input matTooltip="Wildcard searches can be specified with an *" matInput [formControlName]="columnDefinition.searchField ? columnDefinition.searchField : columnDefinition.columnName">
                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="columnDefinition.filterType == 'select'">
                  <mat-form-field>
                    <mat-select [formControlName]="columnDefinition.searchField ? columnDefinition.searchField : columnDefinition.columnName">
                      <mat-option value="">All</mat-option>
                      <ng-container *ngFor="let opt of columnDefinition.filterOptions">
                        <ng-container *ngIf="opt.display != undefined">
                          <mat-option [value]="opt.value">{{opt.display}}</mat-option>
                        </ng-container>
                        <ng-container *ngIf="opt.display == undefined">
                          <mat-option [value]="opt">{{opt}}</mat-option>
                        </ng-container>
                      </ng-container>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
              </th>
            </ng-container>  
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="_columnsToDisplay" class="primary_row text-primary"></tr>
          <ng-container *ngIf="showFilter()">
            <tr mat-header-row *matHeaderRowDef="_filterColumnsToDisplay" class="filter_row"></tr>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: _columnsToDisplay;" (click)="executeSelectItem($event, row)" class="bg-accent-hover alternating-bg" [ngClass]="{'inactive':!checkActive(row), 'selectable':checkSelectable(row)}"></tr>
        </table>
        <div class="d-flex">
          <mat-paginator [length]="resultsLength" [pageSize]="_pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="[5, 10, 20, 50, 100]" [hidePageSize]="hidePageSize" showFirstLastButtons (page)="paginationChange($event)"></mat-paginator>
          <div class="go-to-container">
            <div class="go-to-label">Go To: </div>
            <mat-form-field>
              <mat-select [(ngModel)]="goTo" (selectionChange)="goToPage()">
                <mat-option *ngFor="let pageNumber of pageNumbers" [value]="pageNumber">{{pageNumber}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>